import { FEATURES } from '/src/features/_global/constants';

export const AUDIT_LOG_PERMISSIONS = {
  [FEATURES.AUDIT_LOG]: ({ capabilities }) => ({
    navigate: capabilities.auditTrail.permissions.nav,
    view: capabilities.auditTrail.permissions.view,
  }),
};
